import { RouteConfig, Route } from 'vue-router';
import Layout from '@/layout/index.vue';
import bookingRoutes from './paths/booking';
import reportRoutes from './paths/report';
import planSettingRoutes from './paths/plansetting';
import ticketSettingRoutes from './paths/ticketsetting';
import groupRoutes from './paths/group';
import accountRoutes from './paths/account';
import settingRoutes from './paths/setting';
import testRoutes from './paths/test';
import { setAfterLoginRedirectUrl } from '@/utils/localstorage';

/*
  name:'router-name'             the name field is required when using <keep-alive>, it should also match its component's name property
                                 detail see : https://vuejs.org/v2/guide/components-dynamic-async.html#keep-alive-with-Dynamic-Components
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    roles: ['admin', 'suppiler'] will control the page roles (allow setting multiple roles)
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    hidden: true                 if true, this route will not show in the sidebar (default is false)
    alwaysShow: true             if true, will always show the root menu (default is false)
                                 if false, hide the root menu when has less or equal than one children route
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    noCache: true                if true, the page will not be cached (default is false)
    affix: true                  if true, the tag will affix in the tags-view
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
*/

export const constantRoutesWithoutRoot: RouteConfig[] = [
  {
    path: '/redirect',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '/redirect/:path*',
        component: () =>
          import(
            /* webpackChunkName: "redirect" */ '@/views/redirect/index.vue'
          ),
      },
    ],
  },
  {
    path: '/login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: { hidden: true },
  },
];

/**
  constantRoutes
  a base page that does not have permission requirements
  all roles can be accessed
*/
export const constantRoutes: RouteConfig[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/login',
    children: [
      {
        path: 'home',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
        name: 'Home',
        meta: {
          title: 'Home',
          icon: 'mdi-home-city',
          hidden: true,
        },
      },
    ],
  },
  ...constantRoutesWithoutRoot,
  {
    path: '*',
    redirect: (to: Route) => {
      setAfterLoginRedirectUrl(to.path);
      return '/';
    },
    meta: { hidden: true },
  },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes: RouteConfig[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/booking',
  },
  bookingRoutes,
  {
    path: '/receipt',
    component: () =>
      import(/* webpackChunkName: "receipt" */ '@/views/receipt/index.vue'),
    meta: { hidden: true },
  },
  {
    path: '/qrreader',
    component: Layout,
    meta: { hidden: true, title: 'QRreader' },
    children: [
      {
        path: '',
        component: () =>
          import(
            /* webpackChunkName: "qrreader" */ '@/views/qrreader/index.vue'
          ),
        meta: { hidden: true },
      },
    ],
  },
  reportRoutes,
  {
    path: '*',
    redirect: '/',
    meta: { hidden: true },
  },
  planSettingRoutes,
  ticketSettingRoutes,
  groupRoutes,
  accountRoutes,
  settingRoutes,
  // testRoutes,
];
